import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import GoBackButton from '../../../../components/GoBackButton';
import Tab1MatchedCandidates from './Tab1MatchedCandidates';
import CandidateApplications from './Tab2CandidateApplications';
import Tab3SentCandidates from './Tab3SentCandidates';

const ConSuggestedCandidates = () => {

    const { id, vac } = useParams();

    return (
        <div className="job-bx job-profile">
            <div className="job-bx-title clearfix">
                <h5 className="font-weight-700 pull-left text-uppercase">Candidates</h5>
                <GoBackButton />
            </div>
            <Tabs defaultActiveKey="remaining" className="mb-3">
                <Tab eventKey="remaining" title="Candidates">
                    <Tab1MatchedCandidates id={id} vac={vac} />
                </Tab>
                <Tab eventKey="applied" title="Applied Candidates">
                    <CandidateApplications id={id} />
                </Tab>
                <Tab eventKey="sent" title="Sent Candidates">
                    <Tab3SentCandidates id={id} />
                </Tab>
            </Tabs>
        </div>
    );
};

export default ConSuggestedCandidates;